const windowIfAvailable = (): Window | HTMLElement | any => {
  if(typeof window === `undefined`) return {}
  else return window
}

export default windowIfAvailable
export { windowIfAvailable }